import { FlexiButton } from "@flexinet/ui-components";
import { Message, MessageStatus } from "../types";
import { MdMarkEmailUnread } from "react-icons/md";

interface MarkAsUnreadButtonProps {
    record: Message;
    onClick: (record: Message) => void;
}

export const MarkAsUnreadButton = ({ record, onClick }: MarkAsUnreadButtonProps) => {
    return (
        <FlexiButton 
            variant={'outline'}
            leftSection={<MdMarkEmailUnread />}
            onClick={() => onClick({ ...record, status: MessageStatus.UNREAD })}
        >
            Mark as Unread
        </FlexiButton>
    );
};
